
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandI as ObiOwnShipNoCommandIElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-i.js';
 
 
 

 
 export const ObiOwnShipNoCommandI = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-i',
   elementClass: ObiOwnShipNoCommandIElement,
   events: {
     
   }
  });
 
 